export default "__VITE_ASSET__43794907__"